import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `NivelGenetico/addNivelGenetico`, method: 'POST', body: values, token: token})
}